import React from 'react';
import './Legalpages.css';

const EditorialPolicy = () => {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1>Editorial Policy</h1>
        <p><em>Last updated: May 2026</em></p>

        <h2>Our Commitment to Accuracy</h2>
        <p>
          FocusView.ai is committed to providing accurate, timely, and balanced news coverage.
          Our AI systems surface credible news from established publications and wire services.
          We strive to present information factually and without undue bias.
        </p>

        <h2>Sources</h2>
        <p>
          We aggregate and analyze news from reputable sources including major wire services,
          established news publications, and recognized industry outlets across cryptocurrency,
          artificial intelligence, and political reporting. All sourced content is attributed
          to the original publication.
        </p>

        <h2>AI-Generated Analysis</h2>
        <p>
          Article summaries and analysis on FocusView.ai are generated using artificial
          intelligence. While we strive for accuracy, AI-generated content may occasionally
          contain errors or omissions. We encourage readers to consult primary sources for
          critical decisions.
        </p>

        <h2>Corrections Policy</h2>
        <p>
          If you identify an error in our content, please contact us at{' '}
          <a href="mailto:editorial@focusview.ai">editorial@focusview.ai</a>.
          We review all correction requests and update content as appropriate.
        </p>

        <h2>Independence</h2>
        <p>
          FocusView.ai editorial decisions are made independently of advertising considerations.
          Our loyalty rewards program does not influence the selection or presentation of news content.
        </p>

        <h2>Privacy</h2>
        <p>
          Please review our <a href="/privacy">Privacy Policy</a> for information on how
          we collect and use data.
        </p>
      </div>
    </div>
  );
};

export default EditorialPolicy;
